import type { HabitPersona } from '@/lib/deskHabit';

/** Graduation welcome wording per persona. Tone: Your Next Move™ works for the user — never "monitor"/"track". */
export function graduationCopy(persona: HabitPersona): { lead: string; nextMove: string } {
  switch (persona) {
    case 'buyer':
      return {
        lead: 'Your suppliers are connected and your Buy Request is out working for you.',
        nextMove: 'Your Next Move™ will watch your supplier menus and let you know as soon as new inventory is available — including listings that match what you need.',
      };
    case 'power_trader':
      return {
        lead: 'Both sides of your business are live — your buyers can see your menu, and your suppliers can see what you need.',
        nextMove: 'Your Next Move™ will watch your supplier menus, let you know as soon as new inventory is available, and point out Bridge Matches between your buyers and suppliers — your sources stay private.',
      };
    default:
      return {
        lead: 'Your available inventory is on your VIP Menu and in front of buyers.',
        nextMove: 'Each morning, Your Next Move™ lets you know which buyer to reach and which listing to put forward — so your inventory moves.',
      };
  }
}
